import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import { Spinner } from '@breezeway/brzw-components';
import DonutChartComponent from './donut_chart_component';

import './donut_chart.scss';

const CLASS_NAME = 'donut-chart';

const DonutChart = ({
  className,
  dataSections,
  legend,
  loading,
  onClick,
  radius,
  size,
  startAngle,
  thickness,
}) => {
  const isLoading = useMemo(() => loading, [loading]);
  const isLegend = useMemo(() => _.get(legend, 'render'), [legend.render]);

  return (
    <div className={classnames(`${CLASS_NAME}__wrapper`, className)}>
      {isLegend && <div className={`${CLASS_NAME}__legend-title`}>{_.get(legend, 'title')}</div>}

      {isLoading ? (
        <div className={`${CLASS_NAME} ${CLASS_NAME}__spinner-wrapper`}>
          <Spinner />
        </div>
      ) : (
        <DonutChartComponent
          className={CLASS_NAME}
          dataSections={dataSections}
          isLegend={isLegend}
          legend={legend}
          loading={isLoading}
          onClick={onClick}
          radius={radius}
          size={size}
          startAngle={startAngle}
          thickness={thickness}
        />
      )}
    </div>
  );
};

DonutChart.propTypes = {
  className: PropTypes.string,
  dataSections: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      text: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  legend: PropTypes.shape({
    render: PropTypes.bool,
    title: PropTypes.string,
  }),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  radius: PropTypes.number,
  size: PropTypes.number,
  startAngle: PropTypes.number,
  thickness: PropTypes.number,
};

export default DonutChart;
